<div ref="container" class="aplayer-list" :style="`height:${height}; max-height: ${maxheight}`">
  <ol ref="list"><slot /></ol>
</div>



// WEBPACK FOOTER //
// ./src/components/List/src/List.html